import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Input,
    Button,
    FormControl,
    FormLabel,
    useDisclosure,
    Box,
    Center,
    VStack,
    HStack,
  } from "@chakra-ui/react";
import React,{useState} from "react"
import axios from "axios"


function AlumniAdd() {
    const { isOpen, onOpen, onClose } = useDisclosure()
     const [imgurl,setImageUrl]=useState(null)
     const [name,setName]=useState(null)
     const [marks,setMarks]=useState(null)
     const [about,setAbout]=useState(null)
    const initialRef = React.useRef(null)
    const finalRef = React.useRef(null)
  
const handleSubmit=async()=>{
     if(imgurl==null || name==null || marks==null || about==null){
        alert("Please correct all the details.")
        return ;
     }else{
        try{
          const res=await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/alumni`,{name,marks,about,imgurl})
          alert("Data Save")
        }catch(err){
          alert("Data Not Save")
        }finally {
          // Reset state after submitting the form, whether it succeeded or failed
          setImageUrl(null)
          setName(null)
          setMarks(null)
          setAbout(null)
        }
        
     } 
   
}

    return (
      <>
        <Button colorScheme="teal" onClick={onOpen}>Add Alumni Details</Button>
        
  
        <Modal
          initialFocusRef={initialRef}
          finalFocusRef={finalRef}
          isOpen={isOpen}
          onClose={onClose}
        >
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Add Alumni Details</ModalHeader>
            <ModalCloseButton />
            <ModalBody pb={6}>
              <FormControl>
                <FormLabel>Name</FormLabel>
                <Input ref={initialRef} value={name} onChange={(e)=>setName(e.target.value)} placeholder='Enter  Name' />
              </FormControl>
  
              <FormControl mt={4}>
                <FormLabel>Marks</FormLabel>
                <Input placeholder='Enter Marks or jee,neet' value={marks} onChange={(e)=>setMarks(e.target.value)} />
              </FormControl>
              <FormControl mt={4}>
                <FormLabel>About</FormLabel>
                <Input placeholder='Enter about' value={about} onChange={(e)=>setAbout(e.target.value)} />
              </FormControl>
              <FormControl mt={4}>
                <FormLabel>Image Url</FormLabel>
                <Input placeholder='Enter image url' value={imgurl} onChange={(e)=>setImageUrl(e.target.value)} />
              </FormControl>
            </ModalBody>
  
            <ModalFooter>
              <Button colorScheme='blue' mr={3} onClick={handleSubmit}>
                Save
              </Button>
              <Button onClick={onClose}>Cancel</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    )
  }
  export default AlumniAdd